export default __webpack_public_path__ + "static/media/donation.cb9abaa6.svg";